import type { FC } from 'react';
import { lazy } from 'react-loosely-lazy';
import type { Props as TeamPickerProps } from './ui/edit-mode';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyTeamPickerEdit = lazy<FC<TeamPickerProps>>(
	() =>
		import(/* webpackChunkName: "async-jira-issue-atlassian-team-picker-edit" */ './ui/edit-mode'),
);
